import { PERMISSION_TYPES } from '~/users/containers/Organization/consts.js';

export const getNewCategoryPermissions = (allRolePermissions, categoryPermissions, actionId, newPermission) => {
  let categoryIndex = allRolePermissions.findIndex((c) => c.category === categoryPermissions?.category);
  if (categoryIndex === -1) {
    allRolePermissions.push(categoryPermissions);
    categoryIndex = allRolePermissions.length - 1;
  }
  return getNewCategoryPermissionsHelper(allRolePermissions, categoryIndex, actionId, newPermission);
};

const getNewCategoryPermissionsHelper = (allRolePermissions, categoryIndex, actionId, newPermission) => {
  const categoryActionPermission = {
    permissionType: newPermission ? PERMISSION_TYPES.FULL.id : PERMISSION_TYPES.NONE.id,
  };

  return {
    category: allRolePermissions[categoryIndex].category,
    actionPermissions: [
      {
        action: actionId,
        permissions: [categoryActionPermission],
      },
    ],
  };
};
